import { render, staticRenderFns } from "./CmsRegistAnnual.vue?vue&type=template&id=5d91b2ca&scoped=true&"
import script from "./CmsRegistAnnual.vue?vue&type=script&lang=js&"
export * from "./CmsRegistAnnual.vue?vue&type=script&lang=js&"
import style0 from "./CmsRegistAnnual.vue?vue&type=style&index=0&id=5d91b2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d91b2ca",
  null
  
)

export default component.exports